import { compact, filter, find, first, map } from 'lodash/fp';

import { ProductType } from '../../../../types/product';

const refineProductsByParentId = (parentProductIds: ProductType['parentProductId'][], products: ProductType[]) =>
  compact(
    map((parentProductId) => {
      const filteredItems = filter({ parentProductId }, products);

      return find({ unavailableWithExcessInfo: null }, filteredItems) || first(filteredItems);
    }, parentProductIds),
  );

export default refineProductsByParentId;
